import { Trade } from '@etcswapv2/sdk-legacy'
import { Fragment, memo } from 'react'
import { ChevronRight } from 'react-feather'
import styled from 'styled-components'
import { useTheme } from '../../theme'
import { TYPE } from '../../theme'
import CurrencyLogo from '../CurrencyLogo'

const RouteContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
  padding: 0.5rem 1rem;
  margin: 0.5rem 0;
  border: 1px solid ${({ theme }) => theme.bg3};
  border-radius: 1rem;
`

const TokenContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin: 0.5rem 0;
`

export default memo(function SwapRoute({ trade }: { trade: Trade }) {
  const theme = useTheme()
  return (
    <RouteContainer>
      {trade.route.path.map((token, i, path) => {
        const isLastItem: boolean = i === path.length - 1
        return (
          <Fragment key={i}>
            <TokenContainer>
              <CurrencyLogo currency={token} size="1.5rem" />
              <TYPE.black fontSize={14} color={theme.text1} ml="0.5rem">
                {token.symbol}
              </TYPE.black>
            </TokenContainer>
            {isLastItem ? null : <ChevronRight color={theme.text2} />}
          </Fragment>
        )
      })}
    </RouteContainer>
  )
})
